import varAxios from "../../Comman/axios";
import { GetRegionListUrl,getAlarmStatusColorListUrl, addAlarmStatusColorUrl} from '../../Comman/apiEndPoints';

export const GET_STATUS_COLOR_REQUEST = "GET_STATUS_COLOR_REQUEST";
export const GET_STATUS_COLOR_SUCCESS = "GET_STATUS_COLOR_SUCCESS";
export const UPDATE_STATUS_COLOR_SUCCESS = "UPDATE_STATUS_COLOR_SUCCESS";
export const Fetch_All_Region_Data1 = "Fetch_All_Region_Data1";
export function getAlarmStatusColorList(RegionId) {
    return (dispatch) => {
      dispatch(getStatusColorRequest(true)); 
        return varAxios.post(getAlarmStatusColorListUrl,RegionId,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
            .then((response) => {
              dispatch(
                getStatusColorSuccess(false,response.data.errorCode,response.data.statusCode,
                  response.data.alarmStatusColorList)
              );
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
  export function getStatusColorRequest(isLoading){
    return {
      type : GET_STATUS_COLOR_REQUEST,
      isLoading
    }
  }
  export function getStatusColorSuccess(isLoading,errorCode, statusCode, list){
    return {
      type : GET_STATUS_COLOR_SUCCESS,
      isLoading,
      errorCode,
      statusCode,
      list
    }
  }

  export function addAlarmStatusColor(payload) {
    return (dispatch) => {
      dispatch(getStatusColorRequest(true)); 
        return varAxios.post(addAlarmStatusColorUrl, payload)
            .then((response) => {
              dispatch(
                updateStatusColorSuccess(false,response.data.errorCode,response.data.statusCode,
                  response.data.alarmStatusColorList, response.data.Message)
              );
            })
            .catch((error) => {
                console.log(error)
            })
    }
  }
  export function updateStatusColorSuccess(isLoading,errorCode, statusCode, list, message){
    return {
      type : UPDATE_STATUS_COLOR_SUCCESS,
      isLoading,
      errorCode,
      statusCode,
      list,
      message
    }
  }
   export function getAllRegionSettings() {
      let requestPayload={
    UserId:sessionStorage.getItem('SuperAdminUserID')
  }
    return(dispatch) =>{
       return varAxios.post(GetRegionListUrl,requestPayload,
            JSON.stringify({
                derived: 'd',
                message: 'e'
            }))
       .then(response => {
       
       
        this.getAlarmStatusColorList({RegionId:response.data.regionList[0].ID});
          dispatch(
            fetchAllRegionData({
              errorCode : response.data.errorCode,
              statusCode : response.data.statusCode,
              regionList : response.data.regionList
             }));
       })
       .catch((error) => {
          console.log("error",error);
      })
    }
}
export function fetchAllRegionData({errorCode, statusCode, regionList}) {
  return {
    type : Fetch_All_Region_Data1,
    errorCode,
    statusCode,
    regionList
  }
}